import {useContext, useEffect, useState} from 'react'
import {Button, Col, Row, Stack} from 'react-bootstrap'
import {KTCard, KTCardBody, KTIcon} from '../../../../../_metronic/helpers'

import Select from 'react-select'
import {getAllCompaniesByPais} from '../../../../services/companies'
import {getAllUsersByCompanyPagination} from '../../../../services/users'
import {PartnerContext} from '../PartnerContexts'
import {UnitByRole} from './unit-rol/UnitByRole'
import {UnitByRoleFinal} from './unit-rol/UnitByRoleFinal'

const UnitByRoleTab = () => {
  const {setTabUnitRole} = useContext(PartnerContext)
  const [listDataEmpresas, setListDataEmpresas] = useState<any[]>([])
  const [selectEmpresa, setSelectEmpresa] = useState('')

  const [users, setUsers] = useState<any[]>([])
  const [usersSelected, setUsersSelected] = useState<any[]>([])
  const [usersToModify, setUsersToModify] = useState<any[]>([])
  const [usersToModifySelected, setusersToModifySelected] = useState<any[]>([])

  useEffect(() => {
    refetchDataEmpresas()
  }, [])

  useEffect(() => {
    if (selectEmpresa) {
      setUsers([])
      setUsersSelected([])
      setUsersToModify([])
      setusersToModifySelected([])
      getAllUsersByCompanyPagination(selectEmpresa, {
        estado: true,
      })
        .then((data) => {
          if (data.success) {
            setUsers(data.data)
          } else {
            console.log(data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [selectEmpresa])

  const handleChangeEmpresa = (e: any) => {
    setSelectEmpresa(e.value)
    setTabUnitRole({companyId: e.value})
  }

  const refetchDataEmpresas = async () => {
    await getAllCompaniesByPais()
      .then((response) => {
        if (response.success) {
          const EmpresasNew = response?.data.map((ele: any) => ({
            label: ele.nombre,
            value: ele._id,
          }))
          setListDataEmpresas(EmpresasNew)
        } else {
          console.log(response)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleAddToModify = () => {
    const filterUsersNotSelected = users.filter((u) => !usersSelected.includes(u._id))
    const filterUsersSelected = users.filter((u) => usersSelected.includes(u._id))

    setUsers(filterUsersNotSelected)
    setUsersToModify((prev) => [...filterUsersSelected, ...prev])
    setUsersSelected([])
  }

  const handleAddToUsers = () => {
    const filterUsersModifyNotSelected = usersToModify.filter(
      (u) => !usersToModifySelected.includes(u._id)
    )

    const filterUsersModifySelected = usersToModify.filter((u) =>
      usersToModifySelected.includes(u._id)
    )

    setUsers((prev) => [...filterUsersModifySelected, ...prev])
    setUsersToModify(filterUsersModifyNotSelected)
    setusersToModifySelected([])
  }

  return (
    <>
      <KTCard>
        <KTCardBody>
          <Row>
            <Col xs={10} lg={4} xl={3} sm className='d-flex align-self-end justify-content-start'>
              <Stack direction='vertical' gap={1}>
                <span className='fw-bold'>Seleccione Empresa:</span>
                <Select
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      fontSize: '13px',
                      minHeight: '42px',
                      height: '42px',
                    }),
                  }}
                  options={listDataEmpresas}
                  onChange={handleChangeEmpresa}
                />
              </Stack>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col xs={5} lg={5} xl={5} sm>
              <KTCard>
                <UnitByRole
                  tbody={users}
                  onCheckSelect={(_id: string[]) => setUsersSelected(_id)}
                />
              </KTCard>
            </Col>
            <Col className='d-flex flex-column ' xs={2} lg={2} xl={2} sm>
              <Button className='btn btn-primary mt-10 ' onClick={handleAddToModify}>
                Agregar
                <KTIcon iconName='arrow-right' className='fs-2 mx-3' />
              </Button>

              <Button className='btn btn-secondary mt-3' onClick={handleAddToUsers}>
                <KTIcon iconName='arrow-left' className='fs-2 mx-3' />
                Quitar
              </Button>
            </Col>
            <Col xs={5} lg={5} xl={5} sm>
              <KTCard>
                <UnitByRoleFinal
                  users={usersToModify}
                  onCheckSelect={(_id: string[]) => setusersToModifySelected(_id)}
                />
              </KTCard>
            </Col>
          </Row>
        </KTCardBody>
      </KTCard>
    </>
  )
}

export {UnitByRoleTab}
